import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const UpdateCLookupMetadata = ({
  Show,
  Hide,
  Title,
  getStudyCDISCCLookUp,
  cLookupData,
  studyId,
}) => {
  const [mappingGroup, setMappingGroup] = useState("");
  const [domain, setDomain] = useState("");
  const [testCD, setTestCD] = useState("");
  const [sourceUnit, setSourceUnit] = useState("");
  const [targetUnit, setTargetUnit] = useState("");
  const [factor, setFactor] = useState("");
  const [afineScale, setAfineScale] = useState("");
  const [afineShift, setAfineShift] = useState("");
  const [formula, setFormula] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  useEffect(() => {
    if (cLookupData) {
      setMappingGroup(cLookupData?.mappingGroup || "");
      setDomain(cLookupData?.domain || "");
      setTestCD(cLookupData?.testCD || "");
      setSourceUnit(cLookupData?.sourceUnit || "");
      setTargetUnit(cLookupData?.targetUnit || "");
      setFactor(cLookupData?.factor || "");
      setAfineScale(cLookupData?.afineScale || "");
      setAfineShift(cLookupData?.afineShift || "");
      setFormula(cLookupData?.formula || "");
    }
  }, [cLookupData]);

  const updateStudyCDISCCLookUp = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this clookup?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = cLookupData?._id;
        userData.mappingGroup = mappingGroup;
        userData.domain = domain;
        userData.testCD = testCD;
        userData.sourceUnit = sourceUnit;
        userData.targetUnit = targetUnit;
        userData.factor = factor;
        userData.afineScale = afineScale;
        userData.afineShift = afineShift;
        userData.formula = formula;
        userData.studyId = studyId;
        let data = await cdiscManagementService.updateStudyCDISCCLookUp(userData);
        if (data?.statusCode === 200) {
          getStudyCDISCCLookUp();
          Hide();
        }
        setButtonLoader(false);
      }
    });
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">
            Mapping Group <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={mappingGroup}
            onChange={(e) => setMappingGroup(e.target.value)}
            placeholder="Enter Mapping Group"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Domain</Form.Label>
          <Form.Control
            type="text"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            placeholder="Enter Domain "
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Test CD</Form.Label>
          <Form.Control
            type="text"
            value={testCD}
            onChange={(e) => setTestCD(e.target.value)}
            placeholder="Enter Test CD"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Source Unit</Form.Label>
          <Form.Control
            type="text"
            value={sourceUnit}
            onChange={(e) => setSourceUnit(e.target.value)}
            placeholder="Enter Source Unit"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Target Unit</Form.Label>
          <Form.Control
            type="text"
            value={targetUnit}
            onChange={(e) => setTargetUnit(e.target.value)}
            placeholder="Enter Target Unit"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Factor</Form.Label>
          <Form.Control
            type="text"
            value={factor}
            onChange={(e) => setFactor(e.target.value)}
            placeholder="Enter Factor"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Afine Scale</Form.Label>
          <Form.Control
            type="text"
            value={afineScale}
            onChange={(e) => setAfineScale(e.target.value)}
            placeholder="Enter Afine Scale"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Afine Shift</Form.Label>
          <Form.Control
            type="text"
            value={afineShift}
            onChange={(e) => setAfineShift(e.target.value)}
            placeholder="Enter Afine Shift"
          />
        </Form.Group>
        <Form.Group className="mb-2">
          <Form.Label className="mb-1 fw-bold">Formula</Form.Label>
          <Form.Control
            type="text"
            value={formula}
            onChange={(e) => setFormula(e.target.value)}
            placeholder="Enter Formula"
          />
        </Form.Group>
      </Offcanvas.Body>

      <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
        <button
          onClick={updateStudyCDISCCLookUp}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Updating...
            </div>
          ) : (
            Title
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default UpdateCLookupMetadata;
